import type { KAPLAYCtxT } from 'kaplay'

export default async function (k: KAPLAYCtxT) {
  k.loadSound('sfx_talk', 'sfx/talk.ogg')
  k.loadSound('sfx_action', 'sfx/action.ogg')
  k.loadSound('sfx_footstep', 'sfx/footstep.ogg')
  k.loadSound('sfx_hurt', 'sfx/punch.ogg')
  k.loadSound('sfx_door', 'sfx/door-open.ogg')
  k.loadSound('sfx_stairs', 'sfx/stairs.ogg')
  k.loadSound('sfx_elevator', 'sfx/elevator.ogg')
}
